import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Card, Typography, Tag, Button, Spin} from 'antd'
import { courseActions } from '../../redux/reducers/course';
import Vimeo from '@u-wave/react-vimeo'
import ReactPlayer from 'react-player'

const { Text, Title } = Typography;
const { Meta } = Card;

const LessonView = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user)
    const course = useSelector(state => state.course.course);
    const courseFinished = useSelector(state => state.course.courseFinished)
    const activeLesson = useSelector(state => state.course.activeLesson);
    const lessonSelected = useSelector(state => state.course.lessonSelected);
    
    const lessonLoading = useSelector(state => state.course.lessonLoading);

    const getVideo = (url) =>{ 

        if (url.includes("vimeo")){
            return (
                <Vimeo
                    video={url}
                    responsive
                    color={"14e3ba"}
                    controls={true}
                    showTitle={false}
                />
            )
        }else{
            return (
                    <div className="player-wrapper">
                        <ReactPlayer
                            className='react-player'
                            url={url}
                            width="100%"
                            height="100%"
                            controls={true}
                        />
                    </div>
            )
        }
    }

    return (
        <Spin
            size="large"
            spinning={lessonLoading}
            delay={100}
        >
            <Card
            title={
                <>
                    <Title level={5} style={{float:"left"}} >{course.title}</Title>
                    {
                        !courseFinished ?
                            lessonSelected ?
                                <Button type="primary" size="small" style={{float:"right"}} disabled={lessonLoading}
                                        onClick={()=>{
                                            dispatch(courseActions.setFinishLesson(user.jwt, course.id, activeLesson.id, ""))
                                            }}>
                                    Next Lecture 
                                </Button>
                            : 
                                <Button type="primary" size="small" style={{float:"right"}} disabled={lessonLoading}
                                        onClick={()=>{
                                            dispatch(courseActions.setActiveLesson(user.jwt, course.lessons[0].id))
                                            }}>
                                    Begin First Lecture 
                                </Button>
                        :
                        <Tag color="success" style={{float:"right"}}>Completed</Tag>
                    }
                </>
            }
            style={{
                borderRadius: 10, 
                marginBottom: 25,
                boxShadow: "5px 8px 24px 5px rgba(208, 216, 243, 0.6)" 
            }}
        >
            { !lessonSelected 
                ?
                <> 
                    {course.introVideo &&
                        getVideo(course.introVideo)
                    }
                    <div style={{marginTop:20}}>
                            <div
                                dangerouslySetInnerHTML={{
                                __html: course.description
                                }}>
                            </div>
                    </div>
                </>
                :
                <> 
                    { activeLesson.videoUrl && 
                        getVideo(activeLesson.videoUrl)
                    
                    }
                    <div style={{marginTop:20}}>
                            <div
                                dangerouslySetInnerHTML={{
                                __html: activeLesson.description
                                }}>
                            </div>
                    </div>
                </>
            }
                
                

            <Meta 
            style={{marginTop:20}}
            description={<Text type="secondary" >If you have questions, make sure to contact me at matt@odinplatform.com</Text>} />
        </Card>
        </Spin>
    )
}

export default LessonView
